import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/PolicyPages.css";

const TermsConditions = () => {
  return (
    <>
      <Header />

      <div className="policy-hero">
        <h1>Terms & Conditions</h1>
        <p>
          Please read these terms and conditions carefully before using our
          travel assistance services for Ranthambore tour packages.
        </p>
      </div>

      <div className="policy-wrapper">

        {/* ACCEPTANCE */}
        <div className="policy-section">
          <h2>Acceptance of Terms</h2>
          <p>
            By using this website and requesting travel assistance, you agree
            to comply with and be bound by the following terms and conditions.
            These terms govern your use of our website and the services
            provided through Ranthambore Tours & Travel Assistance.
          </p>
        </div>

        {/* SERVICE NATURE */}
        <div className="policy-section">
          <h2>Nature of Our Service</h2>
          <p>
            Ranthambore Tours & Travel Assistance provides services to help
            travelers plan their Ranthambore trip, including safari experiences,
            accommodation guidance, and local travel support.
          </p>

          <p>
            We are a private travel service provider and are not affiliated with
            the Forest Department or any government authority. Safari experiences
            are conducted by authorised operators as per park regulations.
          </p>
        </div>

        {/* SERVICE PROCESS */}
        <div className="policy-section">
          <h2>Travel Planning Process</h2>
          <p>
            Customers may submit travel enquiries through our website or contact
            us via phone or WhatsApp. Based on the provided details, we assist in
            suggesting suitable tour packages and coordinating travel components
            including safari experiences through authorised operators.
          </p>

          <p>
            Confirmation of travel components depends on availability and the
            policies of authorised operators and park authorities.
          </p>
        </div>

        {/* PAYMENTS */}
        <div className="policy-section">
          <h2>Payments</h2>
          <p>
            In some cases, an advance amount may be required to initiate travel
            planning and coordination. This allows us to proceed with arranging
            relevant travel components based on your requirements.
          </p>

          <p>
            Remaining payment terms will be communicated to the customer during
            the travel planning process.
          </p>
        </div>

        {/* REFUNDS */}
        <div className="policy-section">
          <h2>Cancellation & Refunds</h2>
          <p>
            Refund and cancellation policies are explained in detail on our
            Refund Policy page. Customers are encouraged to review the policy
            before confirming any travel arrangements.
          </p>

          <p>
            Once travel components such as safari experience are confirmed
            through authorised operators, they may become non-refundable as per
            applicable regulations.
          </p>
        </div>

        {/* CUSTOMER RESPONSIBILITY */}
        <div className="policy-section">
          <h2>Customer Responsibilities</h2>
          <p>
            Customers are responsible for providing accurate traveler details
            required for arrangements. Incorrect or incomplete information may
            lead to rejection or cancellation by the respective authorities or
            operators.
          </p>

          <p>
            Customers must also follow all rules and guidelines set by the park
            authorities while visiting Ranthambore National Park.
          </p>
        </div>

        {/* LIABILITY */}
        <div className="policy-section">
          <h2>Limitation of Liability</h2>
          <p>
            Ranthambore Tours & Travel Assistance acts as a travel planning and
            assistance service. We are not responsible for changes in availability,
            park rules, weather conditions, wildlife sightings, or decisions made
            by authorised operators or authorities.
          </p>
        </div>

        {/* CHANGES */}
        <div className="policy-section">
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to update or modify these terms and conditions
            at any time without prior notice. Continued use of the website
            indicates acceptance of the updated terms.
          </p>
        </div>

        {/* CONTACT */}
        <div className="policy-section">
          <h2>Contact Information</h2>
          <p>
            If you have any questions regarding these terms and conditions,
            please contact us:
          </p>

          <p>
            Phone: +91-9217691062 <br />
            Email: support@safariranthamborebooking.com
          </p>
        </div>

      </div>

      
    </>
  );
};

export default TermsConditions;